export class APIResponse {
  status: boolean
  message: string
  errorCode: string
  responseData: any
}

export class TypedResponse<T> extends APIResponse {
  declare public responseData: T
}
